export default function Footer() {
  return (
    <footer className="bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-amber-500">
                <i className="ri-graduation-cap-fill text-white text-lg"></i>
              </div>
              <div>
                <span className="font-bold text-lg leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Crown SAT
                </span>
                <span className="block text-xs text-amber-400 tracking-widest uppercase">&amp; University</span>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-3">
              The premier college prep platform for ambitious students in the USA &amp; Europe. Ivy League results, personalized approach.
            </p>
            <p className="text-white/30 text-xs mb-5">www.CrownSATandUniversity.com</p>
            <div className="flex gap-3">
              {["ri-instagram-line", "ri-twitter-x-line", "ri-facebook-line", "ri-youtube-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:text-white hover:border-white/50 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/80 uppercase tracking-wider">Services</h4>
            <ul className="flex flex-col gap-2.5">
              {["SAT / ACT Test Prep", "1-on-1 Tutoring", "Essay Writing Coaching", "College Application Strategy", "Scholarship Guidance", "Online Group Classes"].map((item) => (
                <li key={item}>
                  <a href="#services" className="text-white/50 text-sm hover:text-amber-400 transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/80 uppercase tracking-wider">Company</h4>
            <ul className="flex flex-col gap-2.5">
              {["About Us", "Our Tutors", "Success Stories", "Blog", "Careers", "Contact"].map((item) => (
                <li key={item}>
                  <a href="#about" className="text-white/50 text-sm hover:text-amber-400 transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/80 uppercase tracking-wider">Contact</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-amber-400"></i>
                </div>
                <span className="text-white/50 text-sm">New York, NY 10001, USA<br />London, UK — EC1A 1BB</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-amber-400"></i>
                </div>
                <a href="mailto:hello@crownsatuniversity.com" className="text-white/50 text-sm hover:text-amber-400 transition-colors cursor-pointer">
                  hello@crownsatuniversity.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-amber-400"></i>
                </div>
                <span className="text-white/50 text-sm">+1 (800) 555-0199</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">&copy; 2026 Crown SAT &amp; University. All rights reserved.</p>
          <div className="flex gap-5">
            {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((item) => (
              <a key={item} href="#" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
